import React from 'react';
import { linkifyText } from '@/utils/linkify';
import type { AgentApiSharedJobPostsContent } from '@/types/serializers';

/** PDF出力用データ型 */
export interface SharedJobPostPdfData {
  title: string;
  /** 企業名（文字列のみ、Company 詳細は持たない） */
  companyName: string;
  /** 提供会社名（任意） */
  providerCompanyName: string | null;
  jobContent: Array<AgentApiSharedJobPostsContent>;
}

/** PDF出力用 SharedJobPost レイアウトコンポーネント */
export const SharedJobPostPrintView: React.FC<{ data: SharedJobPostPdfData }> = ({ data }) => {
  return (
    <div
      className="w-[890px] bg-white px-[55px] pt-[55px] pb-[79px] text-body-sm text-main"
      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      {/* タイトル */}
      <h1 className="mb-md text-center text-heading-lg font-bold">{data.title}</h1>

      {/* 企業情報セクション（簡素版: 企業名と提供会社名のみ） */}
      <div style={{ pageBreakInside: 'avoid' }}>
        {/* セクションヘッダー */}
        <div className="mb-0 border border-solid border-border bg-[#F6F6F6] px-md">
          <h2 className="m-0 flex h-[53px] items-center text-heading-sm font-medium">企業情報</h2>
        </div>

        {/* 企業名 */}
        <div className="flex w-full">
          <div className="flex min-h-[37px] w-[179px] items-center border border-t-0 border-solid border-border bg-[#F6F6F6] px-md font-medium">
            企業名
          </div>
          <div className="flex min-h-[37px] flex-1 items-center border border-t-0 border-l-0 border-solid border-border bg-white px-md">
            {data.companyName}
          </div>
        </div>

        {/* 提供会社名（ある場合のみ表示） */}
        {data.providerCompanyName && (
          <div className="flex w-full">
            <div className="flex min-h-[37px] w-[179px] items-center border border-t-0 border-solid border-border bg-[#F6F6F6] px-md font-medium">
              提供会社名
            </div>
            <div className="flex min-h-[37px] flex-1 items-center border border-t-0 border-l-0 border-solid border-border bg-white px-md">
              {data.providerCompanyName}
            </div>
          </div>
        )}
      </div>

      {/* 求人内容セクション */}
      <div>
        {/* セクションヘッダー */}
        <div className="mb-0 border-x border-b border-solid border-border bg-[#F6F6F6] px-md">
          <h2 className="m-0 flex h-[53px] items-center text-heading-sm font-medium">求人内容</h2>
        </div>

        {/* 求人内容項目 */}
        {data.jobContent.map((item, index) => (
          <div key={index} className="flex w-full" style={{ pageBreakInside: 'avoid' }}>
            <div className="flex w-[179px] items-start border border-t-0 border-solid border-border bg-[#F6F6F6] px-md py-xs text-sm font-medium">
              {item.label}
            </div>
            <div className="flex-1 border border-t-0 border-l-0 border-solid border-border bg-white px-md py-xs text-sm whitespace-pre-wrap">
              {linkifyText(item.content, 'text-link underline')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
